import { useState, useMemo } from 'react';
import { IDLE, defaultStatuses } from '../constants/constants';
import { ApiStatuses } from '../../models/api.interface';

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

const prepareStatuses = (currentStatus: string) => {
  const statuses: ApiStatuses = {
    isIdle: true,
    isPending: false,
    isSuccess: false,
    isError: false,
  };

  for (const status of defaultStatuses) {
    const normalisedStatus = capitalize(status.toLowerCase());
    const normalisedStatusKey = `is${normalisedStatus}`;
    statuses[normalisedStatusKey as keyof ApiStatuses]
      = status === currentStatus;
  }

  return statuses;
};

export const useApiStatus = (currentStatus = IDLE) => {
  const [apiStatus, setApiStatus] = useState(currentStatus);
  const statuses = useMemo(() => prepareStatuses(apiStatus), [apiStatus]);

  return {
    apiStatus,
    setApiStatus,
    ...statuses,
  };
};
